/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Result of capturing a telemetry event
 */
export type CaptureEventResult = {
  /**
   * Whether the event was successfully captured
   */
  success: boolean;
};

/** @internal */
export const CaptureEventResult$inboundSchema: z.ZodMiniType<
  CaptureEventResult,
  unknown
> = z.object({
  success: z.boolean(),
});

export function captureEventResultFromJSON(
  jsonString: string,
): SafeParseResult<CaptureEventResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CaptureEventResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CaptureEventResult' from JSON`,
  );
}
